import React, { history, useEffect, useState, useMemo, useRef } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import moment from "moment";
import Services from "../../services/services";
import $, { parseJSON } from 'jquery';
import UsNumberValidate from '../../utility/usNumberValidate';
import Pagination from "../../utility/Pagination/Pagination";
import { components } from "react-select";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { default as ReactSelect } from "react-select";
import Modal from 'react-modal';



// --- CUSTOM SELECT COMPONENTS ---

const MAX_VISIBLE = 1;      // How many chips to show fully
const MAX_LABEL_LENGTH = 15; // Max characters per chip label before truncation

// 1. Custom Option with Checkbox
const CustomOption = (props) => {
    return (
        <components.Option {...props}>
            <div style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                    style={{ marginRight: 8, flexShrink: 0 }}
                />
                <span
                    title={props.label} // Tooltip with full label on hover
                    style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                >
                    {props.label}
                </span>
            </div>
        </components.Option>
    );
};

//  Custom Value Container (Handles the "+X more" display)
const CustomValueContainer = ({ children, ...props }) => {
    const selected = props.getValue();
    const visible = selected.slice(0, MAX_VISIBLE);
    const hiddenCount = selected.length - MAX_VISIBLE;

    return (
        <components.ValueContainer {...props}>
            <div
                style={{
                    display: "flex",          // Use flexbox
                    alignItems: "center",     // Align vertically center
                    gap: "4px",               // Space between items
                    flexWrap: "nowrap",       // Prevent wrapping to next line
                    overflow: "hidden",       // Avoid overflow issues
                    maxWidth: "100%",         // Constrain width if needed
                }}
            >
                {visible.map(option => (
                    <span
                        key={option.value}
                        style={{
                            display: "inline-block",
                            background: "#eee",
                            borderRadius: 4,
                            padding: "2px 8px",
                            fontSize: 13,
                            maxWidth: 100,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            verticalAlign: "middle",
                        }}
                        title={option.label} // show full text on hover
                    >
                        {option.label.length > MAX_LABEL_LENGTH
                            ? option.label.slice(0, MAX_LABEL_LENGTH) + "..."
                            : option.label}
                    </span>
                ))}

                {hiddenCount > 0 && (
                    <span
                        style={{
                            display: "inline-block",
                            background: "#d7eaff",
                            borderRadius: 4,
                            padding: "2px 8px",
                            fontSize: 13,
                            color: "#2266aa",
                            fontWeight: 600,
                            verticalAlign: "middle",
                            marginLeft: 2,
                        }}
                        title={`${hiddenCount} more`}
                    >
                        +{hiddenCount}
                    </span>
                )}

                {selected.length === 0 && (
                    <span
                        style={{ color: "#808080" }} // Placeholder color
                    >{props.selectProps.placeholder}</span>
                )}

            </div>
            {children[1]} {/* render input/search box */}
        </components.ValueContainer>
    );
};


const AvailableJobsHTOAI = () => {
    const [itemName, setFieldName] = useState('');
    const navigate = useNavigate();
    const [stateData, setStateData] = useState([]);
    const siteID = process.env.React_App_SITE_ID;
    const ITEMS_PER_PAGE = 20; // Per page show the data pagination

    const [menus, setMenus] = useState({ industry: false, location: false, jobType: false, education: false });

    const industryRef = useRef(null);
    const locationRef = useRef(null);
    const jobTypeRef = useRef(null);
    const educationRef = useRef(null);

    const [availableJobsList, setAvailableJobsList] = useState([]);
    const [availableJobsList_m, setAvailableJobsList_m] = useState([]);
    const [availableJobsList_mobile, setAvailableJobsList_mobile] = useState([]);
    const [locationCounty, setLocationCounty] = useState([]);
    const [educations, setEducations] = useState([]);
    const [jobTypes, setJobTypes] = useState([]);
    const [pageOfItems, setPageOfItems] = useState([]);
    const [exampleItems, setExampleItems] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [totalpages, settotalPages] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems_m, setTotalItems_m] = useState(0);
    const [totalpages_m, settotalPages_m] = useState();
    const [currentPage_m, setCurrentPage_m] = useState(1);

    ///mobile job filter variables/////////////////
    const [optionSelected, setoptionSelected] = useState(null);
    const [optionEduSelected, setoptionEduSelected] = useState(null);
    const [optionCatSelected, setoptionCatSelected] = useState(null);
    const [muleducation, setMulEducationTypes] = useState([]);

    const [aiDebugData, setAiDebugData] = useState(null);

    const [categories, setCategory] = useState([]);
    const [mulcategories, setMulCategory] = useState([]);
    const [mullocationCounty, setMulLocationCounty] = useState([]);
    const [mullocationCountyselected, setMulLocationCountyOptionSelected] = useState([]);
    const [muljobTypes, setMulJobTypes] = useState([]);

    const [industryRequestArray, setIndustryRequestArray] = useState([]);
    const [locationRequestArray, setLocationRequestArray] = useState([]);
    const [jobtypeRequestArray, setJobTypeRequestArray] = useState([]);
    const [eduRequestArray, setEduTypeRequestArray] = useState([]);

    // --- AI SPECIFIC STATES ---
    const [searchMode, setSearchMode] = useState("CLASSIC");
    const [aiQuery, setAiQuery] = useState("");
    const [aiLoading, setAiLoading] = useState(false);
    const [aiError, setAiError] = useState("");
    const [aiCurrentPage, setAiCurrentPage] = useState(1);
    const [aiTotalItems, setAiTotalItems] = useState(0);
    const [aiResults, setAiResults] = useState([]);
    const [isClassicLoading, setIsClassicLoading] = useState(true);
    const [hasSearchedAI, setHasSearchedAI] = useState(false);

    ////Web New Design Variables
    const [industryRequestArray_d, setIndustryRequestArrayd] = useState([]);
    const [optionCatSelected_d, setoptionCatSelectedd] = useState([]);
    const [mulcategories_d, setMulCategory_d] = useState([]);

    const [mullocationCountyselected_d, setMulLocationCountyOptionSelectedd] = useState([]);
    const [locationRequestArray_d, setLocationRequestArrayd] = useState([]);
    const [jobtypeRequestArray_d, setJobTypeRequestArrayd] = useState([]);
    const [optionSelected_d, setoptionSelectedd] = useState(null);
    const [eduRequestArray_d, setEduTypeRequestArrayd] = useState([]);
    const [optionEduSelected_d, setoptionEduSelectedd] = useState(null);
    const [optionEduSelected_d_m, setoptionEduSelecteddm] = useState(null);

    const [perks_popup, setPerks_popup] = useState([]);

    var industry_webvar = [];
    var location_webvar = [];
    var jobtype_webvar = [];
    var education_webvar = [];

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    var pagenum = queryParams.get('page');
    const isReturningFromView = queryParams.get('return') === 'true';

    let subtitle;
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [summary, setSummary] = useState('');
    const [url, setUrl] = useState('');
    const [title, setTitle] = useState('');
    var session_pageobj = '';
    var webfilters = 1;
    var mobfilters = 1;

    const {
        register,
        formState: { errors },
        handleSubmit
    } = useForm({
        criteriaMode: "all", mode: "onBlur"
    });

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (industryRef.current && !industryRef.current.contains(event.target)) {
                setMenus(p => ({ ...p, industry: false }));
            }
            if (locationRef.current && !locationRef.current.contains(event.target)) {
                setMenus(p => ({ ...p, location: false }));
            }
            if (jobTypeRef.current && !jobTypeRef.current.contains(event.target)) {
                setMenus(p => ({ ...p, jobType: false }));
            }
            if (educationRef.current && !educationRef.current.contains(event.target)) {
                setMenus(p => ({ ...p, education: false }));
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // --- RESTORE AI STATE ON MOUNT ---
    /*
    useEffect(() => {
        const savedAIStateStr = sessionStorage.getItem('ai_job_search_state');
        if (savedAIStateStr) {
            try {
                const savedAIState = JSON.parse(savedAIStateStr);
                if (savedAIState.searchMode) setSearchMode(savedAIState.searchMode);
                if (savedAIState.aiQuery) setAiQuery(savedAIState.aiQuery);
                if (savedAIState.aiResults) setAiResults(savedAIState.aiResults);
                if (savedAIState.aiCurrentPage) setAiCurrentPage(savedAIState.aiCurrentPage);
                if (savedAIState.aiTotalItems) setAiTotalItems(savedAIState.aiTotalItems);
                if (savedAIState.aiDebugData) setAiDebugData(savedAIState.aiDebugData);
            } catch (e) {
                console.error("Failed to parse saved AI state", e);
            }
        }
    }, []);

    */

    useEffect(() => {
        if (isReturningFromView) {
            // WE CAME FROM THE VIEW PAGE: Restore the state
            const savedAIStateStr = sessionStorage.getItem('ai_job_search_state');
            if (savedAIStateStr) {
                try {
                    const savedAIState = JSON.parse(savedAIStateStr);
                    if (savedAIState.searchMode) setSearchMode(savedAIState.searchMode);
                    //if (savedAIState.aiQuery) setAiQuery(savedAIState.aiQuery);
                    if (savedAIState.aiQuery) {
                        setAiQuery(savedAIState.aiQuery);
                        setHasSearchedAI(true); 
                    }

                    if (savedAIState.aiResults) setAiResults(savedAIState.aiResults);
                    if (savedAIState.aiCurrentPage) setAiCurrentPage(savedAIState.aiCurrentPage);
                    if (savedAIState.aiTotalItems) setAiTotalItems(savedAIState.aiTotalItems);
                    if (savedAIState.aiDebugData) setAiDebugData(savedAIState.aiDebugData);
                } catch (e) {
                    console.error("Failed to parse saved AI state", e);
                }
            }
        } else {
            // DIRECT URL OR MENU CLICK: Clear the old AI state
            sessionStorage.removeItem('ai_job_search_state');
            setSearchMode("CLASSIC"); // Or whatever your default is
            setAiQuery("");
            setAiResults([]);
            setAiTotalItems(0);
            setHasSearchedAI(false);
        }
    }, [isReturningFromView]); // Re-run if this param changes

    // --- HANDLE TAB CHANGE (Persist Mode) ---
    const handleTabChange = (mode) => {
        setSearchMode(mode);
        const existingStateStr = sessionStorage.getItem('ai_job_search_state');
        let existingState = existingStateStr ? JSON.parse(existingStateStr) : {};
        existingState.searchMode = mode;
        sessionStorage.setItem('ai_job_search_state', JSON.stringify(existingState));
    };


    const handleChange = (selected) => {
        var dummArray = [];
        var dummArray_label = [];
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
            dummArray_label.push(selected[i].label.toString());
        }
        setoptionSelected(selected);

        $('#jobtype_selected_m').val(JSON.stringify(dummArray));
        $('#jobtypeLabel_selected_m').val(JSON.stringify(dummArray_label));
        setJobTypeRequestArray(dummArray);
    };

    const mapJobToCardModel = (job, currentPage, mode = "CLASSIC") => {
        // 1. Define the base URL depending on the mode
        const baseUrl = mode === "AI" ? "/aijobsummary" : "/jobsummary";

        return {
            id: job.jobId || job.id,

            title: job.jobTitle || job.title,

            company: job.companyName || job.company,
            jobShadowConcert: job.jobShadowConcert || null,
            //jobShadowConcert
            location: job.city
                ? job.city + (job.state ? ", " + job.state : "")
                : job.location || "",

            postedDate: job.createdDate
                ? moment(job.createdDate).format("MM/DD/YYYY")
                : null,

            summaryHtml:
                mode === "CLASSIC"
                    ? job.summary
                        ? (function () {
                            // 1. Strip HTML tags using regex
                            const cleanText = job.summary.replace(/<[^>]*>?/gm, '');

                            // 2. Truncate and add the link
                            return cleanText.substring(0, 200) +
                                '... <a href="' + baseUrl + '?jobId=' +
                                job.jobId +
                                "&page=" +
                                currentPage +
                                '">View more</a>';
                        })()
                        : ""
                    : job.text
                        ? job.text.substring(0, 220) + "..."
                        : "",

            /*
                summaryHtml:
                mode === "CLASSIC"
                    ? job.summary
                        ? job.summary.substring(0, 200) +
                        '... <a href="' + baseUrl + '?jobId=' +
                        job.jobId +
                        "&page=" +
                        currentPage +
                        '">View more</a>'
                        : ""
                    : job.text
                        ? job.text.substring(0, 220) + "..."
                        : "",
*/
            // 2. Use the dynamically assigned baseUrl here
            jobUrl: baseUrl + "?jobId=" + (job.jobId || job.id) + "&page=" + currentPage,

            logoUrl:
                job.logoUrl ||
                "https://snv3-dev-fs.s3.us-east-2.amazonaws.com/HometownMigration/uploads/default-logo.png",

            matchPercent:
                mode === "AI" && job.score_percent
                    ? Math.round(job.score_percent)
                    : null,

            skills:
                mode === "AI" &&
                    job.skills &&
                    Array.isArray(job.skills)
                    ? job.skills.slice(0, 6)
                    : null,

            perks:
                mode === "AI"
                    ? (
                        job.benefits &&
                            job.benefits.otherBenefits &&
                            Array.isArray(job.benefits.otherBenefits)
                            ? job.benefits.otherBenefits
                            : []
                    )
                        .slice(0, 4)
                        .map(function (p, i) {
                            return {
                                id: i,
                                title: p,
                                icon: mapPerkToIcon(p)
                            };
                        })
                    : (job.perksList || []).map(function (perk) {
                        return {
                            id: perk.perksId,
                            title: perk.perksTitle,
                            icon: perk.perksImageUrl
                        };
                    }),

            showPerks:
                mode === "AI"
                    ? job.benefits &&
                    job.benefits.otherBenefits &&
                    job.benefits.otherBenefits.length > 0
                    : job.perksList && job.perksList.length > 0,

            rawJobData: job
        };
    };


     const runAISearch = async (page) => {
        page = page || 1;
        setSearchMode("AI");
        setAiError("");

        const queryToFetch = aiQuery.trim();

        if (!queryToFetch) {
            setAiError("Please enter a job description.");
            return;
        }

        setAiLoading(true);
        setHasSearchedAI(true);

        try {
            const baseurl = process.env.React_App_AWS_API;

            // 1. Fetch from AI Endpoint
            const aiRes = await fetch(baseurl + "search/jobs", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    query: queryToFetch,
                    useAgent: true,
                    page: page,
                    pageSize: ITEMS_PER_PAGE
                })
            });

            if (!aiRes.ok) {
                throw new Error("Server returned status " + aiRes.status);
            }

            const data = await aiRes.json();

            // Legacy safe null checks
            const fetchedResultsRaw = (data && data.results) ? data.results : [];
            const fetchedTotalItems = (data && data.totalCount !== undefined) ? data.totalCount : fetchedResultsRaw.length;
            const fetchedDebug = (data && data.debug) ? data.debug : null;

            // 2. HYDRATE DATA: Fetch full details for each AI job ID
            const hydratedResults = await Promise.all(
                fetchedResultsRaw.map(async (aiJob) => {
                    try {
                        // Hit your viewJobProfile API (Update domain as needed)
                        //
                        const profileRes = await fetch(baseurl + "viewJobProfile?jobId=" + aiJob.jobId);

                        if (!profileRes.ok) return aiJob;

                        const profileData = await profileRes.json();

                        // 3. Flatten the nested data to match the Classic Search structure safely
                        return {
                            ...aiJob,
                            title: (profileData.jobPostVo && profileData.jobPostVo.title) ? profileData.jobPostVo.title : aiJob.title,
                            summary: (profileData.jobPostVo && profileData.jobPostVo.summary) ? profileData.jobPostVo.summary : aiJob.text,
                            companyName: (profileData.companyVo && profileData.companyVo.name) ? profileData.companyVo.name : aiJob.company,
                            logoUrl: (profileData.companyVo && profileData.companyVo.logoUrl) ? profileData.companyVo.logoUrl : null,
                            perksList: (profileData.companyVo && profileData.companyVo.perksList) ? profileData.companyVo.perksList : [],
                            jobShadowConcert: (profileData.companyVo && profileData.companyVo.jobShadowConcert) ? profileData.companyVo.jobShadowConcert : null,
                            createdDate: (profileData.jobPostVo && profileData.jobPostVo.createdDate) ? profileData.jobPostVo.createdDate : null,
                            city: (profileData.jobPostVo && profileData.jobPostVo.city) ? profileData.jobPostVo.city : aiJob.location_city,
                            state: (profileData.jobPostVo && profileData.jobPostVo.state) ? profileData.jobPostVo.state : aiJob.location_state_abbr,
                        };
                    } catch (err) {
                        console.error("Hydration failed for jobId " + aiJob.jobId, err);
                        return aiJob; // Fallback to raw AI data on network error
                    }
                })
            );

            // 4. Update State with Hydrated Results
            setAiResults(hydratedResults);
            setAiTotalItems(fetchedTotalItems);
            setAiCurrentPage(page);
            setAiDebugData(fetchedDebug);

            // --- SAVE TO SESSION STORAGE FOR "BACK" NAVIGATION ---
            const stateToSave = {
                searchMode: "AI",
                aiQuery: queryToFetch,
                aiResults: hydratedResults,
                aiCurrentPage: page,
                aiTotalItems: fetchedTotalItems,
                aiDebugData: fetchedDebug
            };
            sessionStorage.setItem('ai_job_search_state', JSON.stringify(stateToSave));

        } catch (err) {
            console.error("AI search failed:", err);
            setAiResults([]);
            setAiTotalItems(0);
            setAiError("AI search is temporarily unavailable. Please try again later.");
        } finally {
            setAiLoading(false);
        }
    };

    const runAISearch_to_delete_feb25_2026 = async (page = 1) => {
        setSearchMode("AI");
        setAiError("");

        const queryToFetch = aiQuery.trim();

        if (!queryToFetch) {
            setAiError("Please enter a job description.");
            return;
        }

        setAiLoading(true);

        try {
            const baseurl = process.env.React_App_AWS_API;
            const res = await fetch(`${baseurl}search/jobs`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    query: queryToFetch,
                    useAgent: true,
                    page: page,
                    pageSize: ITEMS_PER_PAGE
                })
            });

            if (!res.ok) {
                throw new Error("Server returned status " + res.status);
            }

            const data = await res.json();
            const fetchedResults = data && data.results ? data.results : [];
            const fetchedTotalItems = data && data.totalCount !== undefined ? data.totalCount : (data && data.results ? data.results.length : 0);
            const fetchedDebug = data && data.debug ? data.debug : null;

            setAiResults(fetchedResults);
            setAiTotalItems(fetchedTotalItems);
            setAiCurrentPage(page);
            setAiDebugData(fetchedDebug);

            // --- SAVE TO SESSION STORAGE FOR "BACK" NAVIGATION ---
            const stateToSave = {
                searchMode: "AI",
                aiQuery: queryToFetch,
                aiResults: fetchedResults,
                aiCurrentPage: page,
                aiTotalItems: fetchedTotalItems,
                aiDebugData: fetchedDebug
            };
            sessionStorage.setItem('ai_job_search_state', JSON.stringify(stateToSave));

        } catch (err) {
            console.error("AI search failed:", err);
            setAiResults([]);
            setAiTotalItems(0);
            setAiError("AI search is temporarily unavailable. Please try again later.");
        } finally {
            setAiLoading(false);
        }
    };

    const handleJobClick = (jobId, rawData) => {
        if (rawData) {
            const completeAiData = {
                search_text_query: aiQuery,
                ...rawData,
                debug: aiDebugData,

            };
            localStorage.setItem(`ai_job_${jobId}`, JSON.stringify(completeAiData));
        }
    };

    const handleAiPageChange = (offset) => {
        runAISearch(offset);
        window.scrollTo({ top: 150, behavior: 'smooth' });
    };

    const mapPerkToIcon = (perk) => {
        const map = {
            "life insurance": "https://www.hometownopportunity.com/images/life-insurance.png",
            "health insurance": "https://www.hometownopportunity.com/images/health.png",
            "dental insurance": "https://www.hometownopportunity.com/images/dental.png",
            "vision insurance": "https://www.hometownopportunity.com/images/vision.png",
            "401k match": "https://www.hometownopportunity.com/images/match.png",
            "retirement plan": "https://www.hometownopportunity.com/images/match.png",
            "stock options": "https://www.hometownopportunity.com/images/stocks.png",
            "referral bonuses": "https://www.hometownopportunity.com/images/dollars.png",
            "paid vacation": "https://www.hometownopportunity.com/images/holiday.png",
            "paid sick days": "https://www.hometownopportunity.com/images/sick.png",
            "paid time off": "https://www.hometownopportunity.com/images/holiday.png",
            "parental leave": "https://www.hometownopportunity.com/images/parent.png",
            "hour lunch break": "https://www.hometownopportunity.com/images/lunch-plate.png",
            "break room coffee bar": "https://www.hometownopportunity.com/images/cofee.png",
            "flexible schedule": "https://www.hometownopportunity.com/images/lunch-plate.png",
            "remote work options": "https://www.hometownopportunity.com/images/perks.png",
            "tuition reimbursement program": "https://www.hometownopportunity.com/images/tutions.png",
            "professional development": "https://www.hometownopportunity.com/images/tutions.png",
            "perks & discounts": "https://www.hometownopportunity.com/images/discounts.png"
        };
        return map[perk.toLowerCase()] || "https://www.hometownopportunity.com/images/perks.png";
    };

    const jobCards = useMemo(() => {
        if (searchMode === "AI") {
            return aiResults.map((job) => mapJobToCardModel(job, aiCurrentPage, "AI"));
        }
        return availableJobsList.map((job) => mapJobToCardModel(job, currentPage, "CLASSIC"));
    }, [searchMode, aiResults, availableJobsList, currentPage, aiCurrentPage]);


    const handleChange_d = (selected) => {
        var dummArray = [];
        var dummArray_label = [];
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
            dummArray_label.push(selected[i].label.toString());
            jobtype_webvar.push(selected[i].value.toString());
        }
        setoptionSelectedd(selected);
        $('#jobtype_selected').val(JSON.stringify(dummArray));
        $('#jobtypeLabel_selected').val(JSON.stringify(dummArray_label));
        setJobTypeRequestArrayd(dummArray);
    };

    const handleChangeForEdu = (selected) => {
        var dummArray = [];
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
        }
        setoptionEduSelected(selected);
        setEduTypeRequestArray(dummArray);
    };

    const handleChangeForEdu_d = (selected) => {
        var dummArray = [];
        var dummArray_label = [];
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
            dummArray_label.push(selected[i].label.toString());
            education_webvar.push(selected[i].value.toString());
        }
        $('#education_selected').val(JSON.stringify(dummArray));
        $('#educationLabel_selected').val(JSON.stringify(dummArray_label));
        setEduTypeRequestArrayd(dummArray);
        setoptionEduSelectedd(selected);
    };

    const handleChangeForEdu_d_m = (selected) => {
        var dummArray = [];
        var dummArray_label = [];
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
            dummArray_label.push(selected[i].label.toString());
            education_webvar.push(selected[i].value.toString());
        }
        setoptionEduSelecteddm(selected);
        $('#education_selected_m').val(JSON.stringify(dummArray));
        $('#educationLabel_selected_m').val(JSON.stringify(dummArray_label));
        setEduTypeRequestArrayd(dummArray);

    };

    const handleChangeForCate = (selected) => {
        var dummArray = [];
        var dummArray_label = [];
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
            dummArray_label.push(selected[i].label.toString());
        }
        setIndustryRequestArray(dummArray);
        $('#industry_selected_m').val(JSON.stringify(dummArray));
        $('#industryLabel_selected_m').val(JSON.stringify(dummArray_label));
        setoptionCatSelected(selected);
    };

    const handleChangeForCate_d = (selected) => {
        var dummArray = [];
        var dummArray_label = [];
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
            dummArray_label.push(selected[i].label.toString());
            industry_webvar.push(selected[i].value.toString());
        }
        setIndustryRequestArrayd(dummArray);
        $('#industry_selected').val(JSON.stringify(dummArray));
        $('#industryLabel_selected').val(JSON.stringify(dummArray_label));
        setoptionCatSelectedd(selected);
    };

    const handleChangeForLocation = (selected) => {
        var dummArray = [];
        var dummArray_label = [];
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
            dummArray_label.push(selected[i].label.toString());
        }
        setMulLocationCountyOptionSelected(selected);
        $('#location_selected_m').val(JSON.stringify(dummArray));
        $('#locationLabel_selected_m').val(JSON.stringify(dummArray_label));
        setLocationRequestArray(dummArray);
    };

    const handleChangeForLocation_d = (selected) => {
        var dummArray = [];
        var dummArray_label = [];
        for (var i = 0; i < selected.length; i++) {
            dummArray.push(selected[i].value.toString());
            dummArray_label.push(selected[i].label.toString());
            location_webvar.push(selected[i].value.toString());
        }
        setMulLocationCountyOptionSelectedd(selected);
        $('#location_selected').val(JSON.stringify(dummArray));
        $('#locationLabel_selected').val(JSON.stringify(dummArray_label));
        setLocationRequestArrayd(dummArray);
    };


    const handlePageChange2_m = (offset, triggerevent) => {
        searchInit_m(ITEMS_PER_PAGE, offset);
    };
    const handlePageChange2 = (offset, triggerevent) => {
        searchInit(ITEMS_PER_PAGE, offset, '0');
    };

    function searchInit_m(ITEMS_PER_PAGE, pageNumber) {
        var searchkey = $('#search_textm').val().trim();
        var industryArray = [];
        $.each($("input[name='industry_m']:checked"), function () {
            industryArray.push($(this).val());
        });
        var locationArray = [];
        $.each($("input[name='location_m']:checked"), function () {
            locationArray.push($(this).val());
        });
        var jobtypeArray = [];
        $.each($("input[name='jobtype_m']:checked"), function () {
            jobtypeArray.push($(this).val());
        });
        var educationArray = [];
        $.each($("input[name='education_m']:checked"), function () {
            educationArray.push($(this).val());
        });

        const requestObject = {
            "searchTxt": searchkey,
            "jobCategory": industryArray,
            "jobLocation": locationArray,
            "jobEducation": educationArray,
            "jobType": jobtypeArray,
            "pageSize": ITEMS_PER_PAGE,
            "pageNumber": pageNumber,
            "sortBy": "jobId",
            "sortDir": "desc",
            "siteId": siteID
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestObject)
        };

        Services.getAvailableJobs(requestOptions).then((res) => {
            if (res.content) {
                setAvailableJobsList_m(res.content);
                window.scrollTo({ top: 100, behavior: 'smooth' });
                setTotalItems_m(res.totalElements);
                settotalPages_m(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
                setCurrentPage_m(pageNumber);
            }
        });
    }

    const submitValue = () => {
        searchInit(ITEMS_PER_PAGE, '1', '0');
    }

    const submitValue_m = () => {
        //mobileFilterCall(ITEMS_PER_PAGE, '1', '0');
    }


    const getFilterData = (selector) => {
        const val = $(selector).val();
        if (!val || val.trim() === "") return [];
        try {
            return JSON.parse(val);
        } catch (e) {
            console.warn(`Invalid JSON in ${selector}, defaulting to empty array.`);
            return [];
        }
    };

    function searchInit(ITEMS_PER_PAGE, pageNumber, setlcstorage) {
        //var searchkey = $('#search_text').val().trim();

        var searchval = $('#search_text').val();
        var searchkey = searchval ? searchval.trim() : "";


        var industries_filter = getFilterData('#industry_selected');
        var locations_filter = getFilterData('#location_selected');
        var educations_filter = getFilterData('#education_selected');
        var jobtypes_filter = getFilterData('#jobtype_selected');


        /*
        var industries_filter = [];
        var selected_ind = $('#industry_selected').val();

        if (selected_ind && selected_ind.trim() !== "") {
            try {
                industries_filter = JSON.parse(selected_ind);
            } catch (e) {
                console.error("Failed to parse industry selection:", e);
                industries_filter = []; // Fallback to empty array
            }
        }

        */

        /*

        var locations_filter = [];
        var selected_loc = $('#location_selected').val();


        try {
            locations_filter = (selected_loc && selected_loc !== '') ? JSON.parse(selected_loc) : [];
        } catch (e) { console.error("Location parse error", e); }
         */


        /*
        var educations_filter = [];
        var selected_edu = $('#education_selected').val();
        if (selected_edu != '') {
            educations_filter = JSON.parse(selected_edu);
        }
        */

        /*
        var educations_filter = [];
        var selected_edu = $('#education_selected').val();
        try {
            educations_filter = (selected_edu && selected_edu !== '') ? JSON.parse(selected_edu) : [];
        } catch (e) { console.error("Education parse error", e); }
        */
        /*
        var jobtypes_filter = [];
        var selected_types = $('#jobtype_selected').val();
        if (selected_types != '') {
            jobtypes_filter = JSON.parse(selected_types);
        }
        */

        if (setlcstorage == "1") {
            var industriesLabel_filter = '';
            var industries_val2 = '';
            var selected_indLabel = $('#industryLabel_selected').val();
            if (selected_indLabel != '') {
                //industriesLabel_filter = JSON.parse(selected_indLabel);
                industriesLabel_filter = getFilterData('#industryLabel_selected');
            }
            var selected_val1 = $('#industry_selected').val();
            if (selected_val1 != '') {
                industries_val2 = JSON.parse(selected_val1);
            }

            var educationLabel_filter = '';
            var education_val2 = '';
            var selected_eduLabel = $('#educationLabel_selected').val();
            if (selected_eduLabel != '') {
                educationLabel_filter = JSON.parse(selected_eduLabel);
            }
            var selected_eduval1 = $('#education_selected').val();
            if (selected_eduval1 != '') {
                education_val2 = JSON.parse(selected_eduval1);
            }

            var locationLabel_filter = '';
            var location_val2 = '';
            var selected_locLabel = $('#locationLabel_selected').val();
            if (selected_locLabel != '') {
                locationLabel_filter = JSON.parse(selected_locLabel);
            }
            var selected_locval1 = $('#location_selected').val();
            if (selected_locval1 != '') {
                location_val2 = JSON.parse(selected_locval1);
            }

            var jobtypeLabel_filter = '';
            var jobtype_val2 = '';
            var selected_jobtypeLabel = $('#jobtypeLabel_selected').val();
            if (selected_jobtypeLabel != '') {
                jobtypeLabel_filter = JSON.parse(selected_jobtypeLabel);
            }
            var selected_jobtypeval1 = $('#jobtype_selected').val();
            if (selected_jobtypeval1 != '') {
                jobtype_val2 = JSON.parse(selected_jobtypeval1);
            }
        }

        var industriesLabel_filter = '';
        var industries_val2 = '';
        var selected_indLabel = $('#industryLabel_selected').val();
        if (selected_indLabel != '') {
            // industriesLabel_filter = JSON.parse(selected_indLabel);
            industriesLabel_filter = getFilterData('#industryLabel_selected');
        }
        var selected_val1 = $('#industry_selected').val();
        if (selected_val1 != '') {
            //industries_val2 = JSON.parse(selected_val1);
            industries_val2 = getFilterData('#industry_selected');
        }

        var educationLabel_filter = '';
        var education_val2 = '';
        var selected_eduLabel = $('#educationLabel_selected').val();
        if (selected_eduLabel != '') {
            // educationLabel_filter = JSON.parse(selected_eduLabel);
            educationLabel_filter = getFilterData('#educationLabel_selected');
        }
        var selected_eduval1 = $('#education_selected').val();
        if (selected_eduval1 != '') {
            //education_val2 = JSON.parse(selected_eduval1);
            education_val2 = getFilterData('#education_selected');
        }

        var locationLabel_filter = '';
        var location_val2 = '';
        var selected_locLabel = $('#locationLabel_selected').val();
        if (selected_locLabel != '') {
            //locationLabel_filter = JSON.parse(selected_locLabel);
            locationLabel_filter = getFilterData('#locationLabel_selected');
        }
        var selected_locval1 = $('#location_selected').val();
        if (selected_locval1 != '') {
            //location_val2 = JSON.parse(selected_locval1);
            location_val2 = getFilterData('#location_selected');
        }

        var jobtypeLabel_filter = '';
        var jobtype_val2 = '';
        var selected_jobtypeLabel = $('#jobtypeLabel_selected').val();
        if (selected_jobtypeLabel != '') {
            // jobtypeLabel_filter = JSON.parse(selected_jobtypeLabel);
            jobtypeLabel_filter = getFilterData('#jobtypeLabel_selected');
        }
        var selected_jobtypeval1 = $('#jobtype_selected').val();
        if (selected_jobtypeval1 != '') {
            // jobtype_val2 = JSON.parse(selected_jobtypeval1);
            jobtype_val2 = getFilterData('#jobtype_selected');
        }

        if (pageNumber > 1) {
            var jsonData = {
                "availableJobs": {
                    "industry": industries_val2,
                    "industry_label": industriesLabel_filter,
                    "education": education_val2,
                    "education_label": educationLabel_filter,
                    "location": location_val2,
                    "location_label": locationLabel_filter,
                    "job_type": jobtype_val2,
                    "job_type_label": jobtypeLabel_filter,
                    "search_text": searchkey,
                    "pagination_val": pageNumber,
                    "industry_m": '',
                    "industry_label_m": '',
                    "education_m": '',
                    "education_label_m": '',
                    "location_m": '',
                    "location_label_m": '',
                    "job_type_m": '',
                    "job_type_label_m": '',
                    "search_text_m": "",
                    "pagination_val_m": '',
                }
            };
        } else {
            var jsonData = {
                "availableJobs": {
                    "industry": industries_val2,
                    "industry_label": industriesLabel_filter,
                    "education": education_val2,
                    "education_label": educationLabel_filter,
                    "location": location_val2,
                    "location_label": locationLabel_filter,
                    "job_type": jobtype_val2,
                    "job_type_label": jobtypeLabel_filter,
                    "search_text": searchkey,
                    "pagination_val": '',
                    "industry_m": '',
                    "industry_label_m": '',
                    "education_m": '',
                    "education_label_m": '',
                    "location_m": '',
                    "location_label_m": '',
                    "job_type_m": '',
                    "job_type_label_m": '',
                    "search_text_m": "",
                    "pagination_val_m": '',
                }
            };
        }

        var jsondataformatted = JSON.stringify(jsonData);
        sessionStorage.setItem('pagejsonObject', jsondataformatted);

        const requestObject = {
            "searchTxt": searchkey,
            "jobCategory": industries_filter,
            "jobLocation": locations_filter,
            "jobEducation": educations_filter,
            "jobType": jobtypes_filter,
            "pageSize": ITEMS_PER_PAGE,
            "pageNumber": pageNumber,
            "sortBy": "jobId",
            "sortDir": "desc",
            "siteId": siteID
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestObject)
        };
        $(".cards").show();
        setIsClassicLoading(true);

        Services.getAvailableJobs(requestOptions).then((res) => {
            if (res.content) {
                setAvailableJobsList(res.content);
                window.scrollTo({ top: 150, behavior: 'smooth' });
                setTotalItems(res.totalElements);
                settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
                setCurrentPage(pageNumber);
            }
            $(".cards").hide();
            setIsClassicLoading(false);

            var ind_master = sessionStorage.getItem('master_industry');
            if (ind_master == null || ind_master == '') load_serviceindustrydata();
            else load_localindustrydata();

            var loc_master = sessionStorage.getItem('master_location');
            if (loc_master == null || loc_master == '') load_servicelocationdata();
            else load_locallocationdata();

            var jobtype_master = sessionStorage.getItem('master_jobtype');
            if (jobtype_master == null || jobtype_master == '') load_servicejobtypedata();
            else load_localjobtypedata();

            var edu_master = sessionStorage.getItem('master_education');
            if (edu_master == null || edu_master == '') load_serviceeducationdata();
            else load_localeducationdata();
        });
    }

    const ClearAll = () => {
        setIndustryRequestArray([]);
        setIndustryRequestArrayd([]);
        setLocationRequestArray([]);
        setLocationRequestArrayd([]);
        setJobTypeRequestArray([]);
        setJobTypeRequestArrayd([]);
        setEduTypeRequestArray([]);
        setEduTypeRequestArrayd([]);
        setoptionSelected("");
        setoptionSelectedd("");
        setoptionCatSelected("");
        setoptionCatSelectedd("");
        setMulLocationCountyOptionSelected("");
        setMulLocationCountyOptionSelectedd("");
        setoptionEduSelected("");
        setoptionEduSelectedd("");
        education_webvar = [];
        location_webvar = [];
        jobtype_webvar = [];
        industry_webvar = [];
        $('#industry_selected').val("");
        $('#location_selected').val("");
        $('#education_selected').val("");
        $('#jobtype_selected').val("");
        $('#search_text').val("");
        $('#industryLabel_selected').val("");
        $('#educationLabel_selected').val("");
        $('#jobtypeLabel_selected').val("");
        $('#locationLabel_selected').val("");

        $('#industry_selected_m').val("");
        $('#industryLabel_selected_m').val("");
        $('#education_selected_m').val("");
        $('#educationLabel_selected_m').val("");
        $('#jobtype_selected_m').val("");
        $('#jobtypeLabel_selected_m').val("");
        $('#location_selected_m').val("");
        $('#locationLabel_selected_m').val("");
        $('#search_textm').val("");

        searchInit(ITEMS_PER_PAGE, '1', '0');
    }

    const mobileFilterCall = (ITEMS_PER_PAGE, pageNumber, setlcstorage) => {
        var searchkey = $('#search_text').val().trim();
        var industryRequestArray = [];
        var selected_ind = $('#industry_selected_m').val();
        var locationRequestArray = [];
        var selected_loc = $('#location_selected_m').val();
        var jobtypeRequestArray = [];
        var selected_types = $('#jobtype_selected_m').val();

        if (setlcstorage == "1") {
            var industriesLabel_filter = '';
            var industries_val2 = '';
            var selected_indLabel = $('#industryLabel_selected').val();
            if (selected_indLabel != '') industriesLabel_filter = JSON.parse(selected_indLabel);
            var selected_val1 = $('#industry_selected').val();
            if (selected_val1 != '') industries_val2 = JSON.parse(selected_val1);

            var educationLabel_filter = '';
            var education_val2 = '';
            var selected_eduLabel = $('#educationLabel_selected').val();
            if (selected_eduLabel != '') educationLabel_filter = JSON.parse(selected_eduLabel);
            var selected_eduval1 = $('#education_selected').val();
            if (selected_eduval1 != '') education_val2 = JSON.parse(selected_eduval1);

            var locationLabel_filter = '';
            var location_val2 = '';
            var selected_locLabel = $('#locationLabel_selected').val();
            if (selected_locLabel != '') locationLabel_filter = JSON.parse(selected_locLabel);
            var selected_locval1 = $('#location_selected').val();
            if (selected_locval1 != '') location_val2 = JSON.parse(selected_locval1);

            var jobtypeLabel_filter = '';
            var jobtype_val2 = '';
            var selected_jobtypeLabel = $('#jobtypeLabel_selected').val();
            if (selected_jobtypeLabel != '') jobtypeLabel_filter = JSON.parse(selected_jobtypeLabel);
            var selected_jobtypeval1 = $('#jobtype_selected').val();
            if (selected_jobtypeval1 != '') jobtype_val2 = JSON.parse(selected_jobtypeval1);
        }

        var industriesLabel_filter_m = '';
        var industries_val2_m = '';
        var selected_indLabel_m = $('#industryLabel_selected_m').val();
        if (selected_indLabel_m != '') industriesLabel_filter_m = JSON.parse(selected_indLabel_m);
        var selected_val1_m = $('#industry_selected_m').val();
        if (selected_val1_m != '') industries_val2_m = JSON.parse(selected_val1_m);

        var educationLabel_filter_m = '';
        var education_val2_m = '';
        var selected_eduLabel_m = $('#educationLabel_selected_m').val();
        if (selected_eduLabel_m != '') educationLabel_filter_m = JSON.parse(selected_eduLabel_m);
        var selected_eduval1_m = $('#education_selected_m').val();
        if (selected_eduval1_m != '') education_val2_m = JSON.parse(selected_eduval1_m);

        var locationLabel_filter_m = '';
        var location_val2_m = '';
        var selected_locLabel_m = $('#locationLabel_selected_m').val();
        if (selected_locLabel_m != '') locationLabel_filter_m = JSON.parse(selected_locLabel_m);
        var selected_locval1_m = $('#location_selected_m').val();
        if (selected_locval1_m != '') location_val2_m = JSON.parse(selected_locval1_m);

        var jobtypeLabel_filter_m = '';
        var jobtype_val2_m = '';
        var selected_jobtypeLabel_m = $('#jobtypeLabel_selected_m').val();
        if (selected_jobtypeLabel_m != '') jobtypeLabel_filter_m = JSON.parse(selected_jobtypeLabel_m);
        var selected_jobtypeval1_m = $('#jobtype_selected_m').val();
        if (selected_jobtypeval1_m != '') jobtype_val2_m = JSON.parse(selected_jobtypeval1_m);

        if (pageNumber > 1) {
            var jsonData = {
                "availableJobs": {
                    "industry": '', "industry_label": '', "education": '', "education_label": '', "location": '', "location_label": '', "job_type": '', "job_type_label": '', "search_text": '', "pagination_val": '',
                    "industry_m": selected_val1_m, "industry_label_m": selected_indLabel_m, "education_m": selected_eduval1_m, "education_label_m": selected_eduLabel_m, "location_m": selected_locval1_m, "location_label_m": selected_locLabel_m, "job_type_m": selected_jobtypeval1_m, "job_type_label_m": selected_jobtypeLabel_m, "search_text_m": "", "pagination_val_m": pageNumber,
                }
            };
        } else {
            var jsonData = {
                "availableJobs": {
                    "industry": '', "industry_label": '', "education": '', "education_label": '', "location": '', "location_label": '', "job_type": '', "job_type_label": '', "search_text": '', "pagination_val": '',
                    "industry_m": selected_val1_m, "industry_label_m": selected_indLabel_m, "education_m": selected_eduval1_m, "education_label_m": selected_eduLabel_m, "location_m": selected_locval1_m, "location_label_m": selected_locLabel_m, "job_type_m": selected_jobtypeval1_m, "job_type_label_m": selected_jobtypeLabel_m, "search_text_m": "", "pagination_val_m": '',
                }
            };
        }

        var jsondataformatted = JSON.stringify(jsonData);
        sessionStorage.setItem('pagejsonObject', jsondataformatted);

        const requestObject = {
            "searchTxt": "",
            "jobCategory": industryRequestArray,
            "jobLocation": locationRequestArray,
            "jobEducation": eduRequestArray,
            "jobType": jobtypeRequestArray,
            "pageSize": ITEMS_PER_PAGE,
            "pageNumber": pageNumber,
            "sortBy": "jobId",
            "sortDir": "desc",
            "siteId": siteID
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestObject)
        };
        $(".cards").show();
        Services.getAvailableJobs(requestOptions).then((res) => {
            if (res.content) {
                setAvailableJobsList_mobile(res.content);
                window.scrollTo({ top: 100, behavior: 'smooth' });
                setTotalItems_m(res.totalElements);
                settotalPages_m(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
                setCurrentPage_m(pageNumber);
                document.getElementById("closeMobilePopup").click();
            }
        });
        $(".cards").hide();

        var ind_master = sessionStorage.getItem('master_industry');
        if (ind_master == null || ind_master == '') load_serviceindustrydata();
        else load_localindustrydata();

        var loc_master = sessionStorage.getItem('master_location');
        if (loc_master == null || loc_master == '') load_servicelocationdata();
        else load_locallocationdata();

        var jobtype_master = sessionStorage.getItem('master_jobtype');
        if (jobtype_master == null || jobtype_master == '') load_servicejobtypedata();
        else load_localjobtypedata();

        var edu_master = sessionStorage.getItem('master_education');
        if (edu_master == null || edu_master == '') load_serviceeducationdata();
        else load_localeducationdata();
    }

    useEffect(() => {
        $(".cards").hide();
        var keys = sessionStorage.getItem('pagejsonObject');

        if (!isReturningFromView) {
            sessionStorage.removeItem('pagejsonObject');
            sessionStorage.removeItem('master_industry');
            sessionStorage.removeItem('master_location');
            sessionStorage.removeItem('master_jobtype');
            sessionStorage.removeItem('master_education');
            
            // Start completely fresh
            searchInit(ITEMS_PER_PAGE, '1', '0');
            return; // Exit the useEffect early
        }
        if (keys == null || keys == undefined) {
            navigate('/Home');
        } else {
            var keys_parsed = JSON.parse(keys);
            var pageobject = Object.keys(keys_parsed);
            if (pageobject.length > 0) {
                var firstKey = pageobject[0];
                if (firstKey == 'availableJobs') {
                    var pageobj = keys_parsed[firstKey];
                    session_pageobj = keys_parsed[firstKey];
                    var dev_poff = pageobj['pagination_val'];
                    var dev_poff_m = pageobj['pagination_val_m'];
                    if (dev_poff == '') {
                        if (dev_poff_m == '') pagenum = '1';
                        else pagenum = dev_poff_m;
                    } else {
                        pagenum = dev_poff;
                    }
                } else {
                    pagenum = '1';
                    sessionStorage.removeItem('master_industry');
                    sessionStorage.removeItem('master_location');
                    sessionStorage.removeItem('master_jobtype');
                    sessionStorage.removeItem('master_education');
                }
            } else {
                pagenum = '1';
                sessionStorage.removeItem('master_industry');
                sessionStorage.removeItem('master_location');
                sessionStorage.removeItem('master_jobtype');
                sessionStorage.removeItem('master_education');
            }
        }

        if (pagenum == null || pagenum == '') {
            var web_searchtxt = session_pageobj['search_text'];
            var web_education = session_pageobj['education'];
            var web_industry = session_pageobj['industry'];
            var web_jobtype = session_pageobj['jobtype'];
            var web_location = session_pageobj['location'];
            if (web_searchtxt == '' && web_education == '' && web_industry == '' && web_jobtype == '' && web_location == '') {
                var webfilters = 0;
            }

            var mob_searchtxt = session_pageobj['search_text_m'];
            var mob_education = session_pageobj['education_m'];
            var mob_industry = session_pageobj['industry_m'];
            var mob_jobtype = session_pageobj['jobtype_m'];
            var mob_location = session_pageobj['location_m'];
            if (mob_searchtxt == '' && mob_education == '' && mob_industry == '' && mob_jobtype == '' && mob_location == '') {
                var mobfilters = 0;
            }

            if (webfilters == 0 && mobfilters == 0) {
                var jsonData = {
                    "availableJobs": {
                        "industry": '', "industry_label": '', "education": '', "education_label": '', "location": '', "location_label": '', "job_type": '', "job_type_label": '', "search_text": "", "pagination_val": '',
                        "industry_m": '', "industry_label_m": '', "education_m": '', "education_label_m": '', "location_m": '', "location_label_m": '', "job_type_m": '', "job_type_label_m": '', "search_text_m": "", "pagination_val_m": '',
                    }
                };

                var jsondataformatted = JSON.stringify(jsonData);
                sessionStorage.setItem('pagejsonObject', jsondataformatted);
            }
        }

        $('#yourphone2').usPhoneFormat();
        $("#step1").show();
        $("#step2").hide();
        $("#step3").hide();
        $("#step4").hide();
        $("#step5").hide();

        var siteurlval = document.URL;
        var spliturl = siteurlval.split(/[/]/);
        var urllength = spliturl.length;
        setUrl(spliturl[urllength - 1]);

        var t_av_search_text = session_pageobj['search_text'];
        $("#search_text").val(t_av_search_text);

        var t_av_search_text_m = session_pageobj['search_text_m'];
        $("#search_textm").val(t_av_search_text_m);

        load_selectedindustries();
        load_selectededucations();
        load_selectedlocations();
        load_selectedjobtypes();

        if (pagenum != null && pagenum != '') {
            var web_ind = session_pageobj['industry'];
            var web_edu = session_pageobj['education'];
            var web_loc = session_pageobj['location'];
            var web_typ = session_pageobj['job_type'];
            var web_src = session_pageobj['search_text'];
            var pageoffset = session_pageobj['pagination_val'];

            if (web_ind != "" || web_edu != '' || web_loc != '' || web_typ != '' || web_src != '' || pageoffset != '') {
                setTimeout(() => {
                    searchInit(ITEMS_PER_PAGE, pagenum, '0');
                }, 500);
            } else {
                var mob_ind = session_pageobj['industry_m'];
                var mob_edu = session_pageobj['education_m'];
                var mob_loc = session_pageobj['location_m'];
                var mob_typ = session_pageobj['job_type_m'];
                var mob_src = session_pageobj['search_text_m'];
                var pageoffset_m = session_pageobj['pagination_val_m'];

                if (mob_ind != "" || mob_edu != '' || mob_loc != '' || mob_typ != '' || mob_src != '' || pageoffset_m != '') {
                    setTimeout(() => { }, 500);
                } else {
                    searchInit(ITEMS_PER_PAGE, pagenum, '0');
                }
            }
        } else {
            searchInit(ITEMS_PER_PAGE, '1', '0');
        }

        try {
            var t_av_search_text = session_pageobj['search_text'];
            $("#search_text").val(t_av_search_text);
            var t_av_location_selected = session_pageobj['location'];
            var t_av_education_selected = session_pageobj['education'];
            var t_jobtype_selected = session_pageobj['job_type'];
            var t_av_industry_selected = session_pageobj['industry'];

            if (t_av_location_selected != '' || t_av_location_selected != null) {
                var t_av_location_selected_ar = t_av_location_selected.split(",");
                var t_av_education_selected_ar = t_av_education_selected.split(",");
                var t_jobtype_selected_ar = t_jobtype_selected.split(",");
                var t_av_industry_selected_ar = t_av_industry_selected.split(",");
            }
            setoptionEduSelected(t_av_education_selected_ar);
        } catch (ex) { }

    }, []);

    function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };

    const load_serviceindustrydata = () => {
        Services.getIndustryData().then((res) => {
            setCategory(res.data.content);
            var serviceresponse = res.data.content;
            var dummArray = [];
            for (var i = 0; i < res.data.content.length; i++) {
                dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].catId })
            }
            setMulCategory(dummArray);
            setMulCategory_d(dummArray);
            var storeval = JSON.stringify(serviceresponse);
            sessionStorage.setItem('master_industry', storeval);
        });
        load_selectedindustries();
    }

    const load_localindustrydata = () => {
        var localindustryval = sessionStorage.getItem('master_industry');
        localindustryval = JSON.parse(localindustryval);
        var dummArray = [];
        for (var i = 0; i < localindustryval.length; i++) {
            dummArray.push({ "label": localindustryval[i].name, "value": localindustryval[i].catId })
        }
        setMulCategory(dummArray);
        setMulCategory_d(dummArray);
        load_selectedindustries();
    }

    const load_serviceeducationdata = () => {
        Services.getEducation().then((res) => {
            setEducations(res.data.content);
            var serviceresponse = res.data.content;
            var dummArray = [];
            for (var i = 0; i < res.data.content.length; i++) {
                dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].educationId })
            }
            setMulEducationTypes(dummArray);
            var storeeduval = JSON.stringify(serviceresponse);
            sessionStorage.setItem('master_education', storeeduval);
        });
        load_selectededucations();
    }

    const load_localeducationdata = () => {
        var localeducationval = sessionStorage.getItem('master_education');
        localeducationval = JSON.parse(localeducationval);
        var dummArray = [];
        for (var i = 0; i < localeducationval.length; i++) {
            dummArray.push({ "label": localeducationval[i].name, "value": localeducationval[i].educationId })
        }
        setMulEducationTypes(dummArray);
        load_selectededucations();
    }

    const load_servicejobtypedata = () => {
        Services.getJobType().then((res) => {
            var jobtype_unsort = res.data.content;
            var serviceresponse = res.data.content;
            var jobtypes_sorted = jobtype_unsort.sort((a, b) => b.jobTypeId - a.jobTypeId);
            array_move(jobtypes_sorted, 0, (jobtypes_sorted.length - 1));
            jobtypes_sorted = jobtypes_sorted.filter(function (elem) {
                return elem.name !== 'Continuing Education';
            });
            setJobTypes(jobtypes_sorted);
            var dummArray = [];
            for (var i = 0; i < jobtypes_sorted.length; i++) {
                var jobtypename = jobtypes_sorted[i].name;
                var typename = jobtypename.split("(");
                dummArray.push({ "label": typename[0], "value": jobtypes_sorted[i].jobTypeId })
            }
            dummArray.reverse();
            setMulJobTypes(dummArray);
            var storetypeval = JSON.stringify(serviceresponse);
            sessionStorage.setItem('master_jobtype', storetypeval);
        });
        load_selectedjobtypes();
    }

    const load_localjobtypedata = () => {
        var localjobtypeval = sessionStorage.getItem('master_jobtype');
        localjobtypeval = JSON.parse(localjobtypeval);
        var jobtypes_sorted = localjobtypeval.sort((a, b) => b.jobTypeId - a.jobTypeId);
        array_move(jobtypes_sorted, 0, (jobtypes_sorted.length - 1));
        jobtypes_sorted = jobtypes_sorted.filter(function (elem) {
            return elem.name !== 'Continuing Education';
        });
        setJobTypes(jobtypes_sorted);
        var dummArray = [];
        for (var i = 0; i < jobtypes_sorted.length; i++) {
            var jobtypename = jobtypes_sorted[i].name;
            var typename = [];
            if (jobtypename != undefined || jobtypename != null) {
                var typename = jobtypename.split("(");
            }
            dummArray.push({ "label": typename[0], "value": jobtypes_sorted[i].jobTypeId })
        }
        dummArray.reverse();
        setMulJobTypes(dummArray);
        load_selectedjobtypes();
    }

    const load_servicelocationdata = () => {
        Services.getLocationCounty().then((res) => {
            setLocationCounty(res.data.content);
            var serviceresponse = res.data.content;
            var dummArray = [];
            for (var i = 0; i < res.data.content.length; i++) {
                dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].jobLocationCountyId })
            }
            setMulLocationCounty(dummArray);
            var storelocval = JSON.stringify(serviceresponse);
            sessionStorage.setItem('master_location', storelocval);
        });
        load_selectedlocations();
    }

    const load_locallocationdata = () => {
        var locallocationval = sessionStorage.getItem('master_location');
        locallocationval = JSON.parse(locallocationval);
        var dummArray = [];
        for (var i = 0; i < locallocationval.length; i++) {
            dummArray.push({ "label": locallocationval[i].name, "value": locallocationval[i].jobLocationCountyId })
        }
        setMulLocationCounty(dummArray);
        load_selectedlocations();
    }

    const load_selectedindustries = () => {
        var loc_indid = session_pageobj['industry'];
        var loc_indlabel = session_pageobj['industry_label'];

        if (loc_indid != undefined && loc_indid != null && loc_indid != "") {
            var loc_indids = loc_indid.toString();
            var loc_indid1 = loc_indids.split(',');

            var loc_indlabels = loc_indlabel.toString();
            var loc_indlabel1 = loc_indlabels.split(',');

            var industry_locstore = [];
            var temparray_ind = [];
            var temparray_ind_l = [];
            for (var o = 0; o < loc_indid1.length; o++) {
                var temp_object = {
                    "label": loc_indlabel1[o],
                    "value": loc_indid1[o]
                };
                temparray_ind.push(loc_indid1[o]);
                temparray_ind_l.push(loc_indlabel1[o]);
                industry_locstore.push(temp_object);
            }
            setoptionCatSelectedd(industry_locstore);
            $('#industry_selected').val(JSON.stringify(temparray_ind));
            $('#industryLabel_selected').val(JSON.stringify(temparray_ind_l));
        }

        var loc_indid_m = session_pageobj['industry_m'];
        var loc_indlabel_m = session_pageobj['industry_label_m'];

        if (loc_indid_m != undefined && loc_indid_m != null && loc_indid_m != "") {
            var loc_indids_m = loc_indid_m.toString();
            var loc_indid1_m = loc_indids_m.split(',');

            var loc_indlabels_m = loc_indlabel_m.toString();
            var loc_indlabel1_m = loc_indlabels_m.split(',');

            var industry_locstore_m = [];
            var temparray_ind_m = [];
            var temparray_indlab_m = [];
            for (var o = 0; o < loc_indid1_m.length; o++) {
                var temp_object_m = {
                    "label": loc_indlabel1_m[o],
                    "value": loc_indid1_m[o]
                };
                temparray_ind_m.push(loc_indid1_m[o]);
                temparray_indlab_m.push(loc_indlabel1_m[o]);
                industry_locstore_m.push(temp_object_m);
            }
            setoptionCatSelected(industry_locstore_m);
            $('#industry_selected_m').val(JSON.stringify(temparray_ind_m));
            $('#industryLabel_selected_m').val(JSON.stringify(temparray_indlab_m));
        }
    }

    const load_selectededucations = () => {
        var loc_eduid = session_pageobj['education'];
        var loc_edulabel = session_pageobj['education_label'];

        if (loc_eduid != undefined && loc_eduid != null && loc_eduid != "") {
            var loc_eduids = loc_eduid.toString();
            var loc_eduid1 = loc_eduids.split(',');

            var loc_edulabels = loc_edulabel.toString();
            var loc_edulabel1 = loc_edulabels.split(',');

            var education_locstore = [];
            var temparray_edu = [];
            var temparray_edulabel = [];
            for (var e = 0; e < loc_eduid1.length; e++) {
                var temp_object_edu = {
                    "label": loc_edulabel1[e],
                    "value": loc_eduid1[e]
                };
                temparray_edu.push(loc_eduid1[e]);
                temparray_edulabel.push(loc_edulabel1[e]);
                education_locstore.push(temp_object_edu);
            }
            setoptionEduSelectedd(education_locstore);
            $('#education_selected').val(JSON.stringify(temparray_edu));
            $('#educationLabel_selected').val(JSON.stringify(temparray_edulabel));
        }

        var loc_eduid_m = session_pageobj['education_m'];
        var loc_edulabel_m = session_pageobj['education_label_m'];

        if (loc_eduid_m != undefined && loc_eduid_m != null && loc_eduid_m != "") {
            var loc_eduids_m = loc_eduid_m.toString();
            var loc_eduid1_m = loc_eduids_m.split(',');

            var loc_edulabels_m = loc_edulabel_m.toString();
            var loc_edulabel1_m = loc_edulabels_m.split(',');

            var education_locstore_m = [];
            var temparray_edu_m = [];
            var temparray_edulabel_m = [];
            for (var e = 0; e < loc_eduid1_m.length; e++) {
                var temp_object_edu_m = {
                    "label": loc_edulabel1_m[e],
                    "value": loc_eduid1_m[e]
                };
                temparray_edu_m.push(loc_eduid1_m[e]);
                temparray_edulabel_m.push(loc_edulabel1_m[e]);
                education_locstore_m.push(temp_object_edu_m);

            }
            setoptionEduSelecteddm(education_locstore_m);
            $('#education_selected_m').val(JSON.stringify(temparray_edu_m));
            $('#educationLabel_selected_m').val(JSON.stringify(temparray_edulabel_m));
        }
    }

    const load_selectedlocations = () => {
        var loc_locid = session_pageobj['location'];
        var loc_loclabel = session_pageobj['location_label'];

        if (loc_locid != undefined && loc_locid != null && loc_locid != "") {
            var loc_locids = loc_locid.toString();
            var loc_locid1 = loc_locids.split(',');

            var loc_loclabels = loc_loclabel.toString();
            var loc_loclabel1 = loc_loclabels.split(',');

            var location_locstore = [];
            var temparray_loc = [];
            var temparray_loclabel = [];
            for (var l = 0; l < loc_locid1.length; l++) {
                var temp_object_loc = {
                    "label": loc_loclabel1[l],
                    "value": loc_locid1[l]
                };
                temparray_loc.push(loc_locid1[l]);
                temparray_loclabel.push(loc_loclabel1[l]);
                location_locstore.push(temp_object_loc);
            }
            setMulLocationCountyOptionSelectedd(location_locstore);
            $('#location_selected').val(JSON.stringify(temparray_loc));
            $('#locationLabel_selected').val(JSON.stringify(temparray_loclabel));
        }

        var loc_locid_m = session_pageobj['location_m'];
        var loc_loclabel_m = session_pageobj['location_label_m'];

        if (loc_locid_m != undefined && loc_locid_m != null && loc_locid_m != "") {
            var loc_locids_m = loc_locid_m.toString();
            var loc_locid1_m = loc_locids_m.split(',');

            var loc_loclabels_m = loc_loclabel_m.toString();
            var loc_loclabel1_m = loc_loclabels_m.split(',');

            var location_locstore_m = [];
            var temparray_loc_m = [];
            var temparray_loclabel_m = [];
            for (var l = 0; l < loc_locid1_m.length; l++) {
                var temp_object_loc_m = {
                    "label": loc_loclabel1_m[l],
                    "value": loc_locid1_m[l]
                };
                temparray_loc_m.push(loc_locid1_m[l]);
                temparray_loclabel_m.push(loc_loclabel1_m[l]);
                location_locstore_m.push(temp_object_loc_m);
            }
            setMulLocationCountyOptionSelected(location_locstore_m);
            $('#location_selected_m').val(JSON.stringify(temparray_loc_m));
            $('#locationLabel_selected_m').val(JSON.stringify(temparray_loclabel_m));
        }

    }

    const load_selectedjobtypes = () => {
        var loc_jobtypeid = session_pageobj['job_type'];
        var loc_jobtypelabel = session_pageobj['job_type_label'];

        if (loc_jobtypeid != undefined && loc_jobtypeid != null && loc_jobtypeid != "") {
            var loc_jobtypeids = loc_jobtypeid.toString();
            var loc_jobtypeid1 = loc_jobtypeids.split(',');

            var loc_jobtypelabels = loc_jobtypelabel.toString();
            var loc_jobtypelabel1 = loc_jobtypelabels.split(',');

            var jobtype_locstore = [];
            var temparray_jobtype = [];
            var temparray_jobtypelabel = [];
            for (var j = 0; j < loc_jobtypeid1.length; j++) {
                var temp_object_jobtype = {
                    "label": loc_jobtypelabel1[j],
                    "value": loc_jobtypeid1[j]
                };
                temparray_jobtype.push(loc_jobtypeid1[j]);
                temparray_jobtypelabel.push(loc_jobtypelabel1[j]);
                jobtype_locstore.push(temp_object_jobtype);
            }
            setoptionSelectedd(jobtype_locstore);
            $('#jobtype_selected').val(JSON.stringify(temparray_jobtype));
            $('#jobtypeLabel_selected').val(JSON.stringify(temparray_jobtypelabel));
        }

        var loc_jobtypeid_m = session_pageobj['job_type_m'];
        var loc_jobtypelabel_m = session_pageobj['job_type_label_m'];

        if (loc_jobtypeid_m != undefined && loc_jobtypeid_m != null && loc_jobtypeid_m != "") {
            var loc_jobtypeids_m = loc_jobtypeid_m.toString();
            var loc_jobtypeid1_m = loc_jobtypeids_m.split(',');

            var loc_jobtypelabels_m = loc_jobtypelabel_m.toString();
            var loc_jobtypelabel1_m = loc_jobtypelabels_m.split(',');

            var jobtype_locstore_m = [];
            var temparray_jobtype_m = [];
            var temparray_jobtypelabel_m = [];
            for (var j = 0; j < loc_jobtypeid1_m.length; j++) {
                var temp_object_jobtype_m = {
                    "label": loc_jobtypelabel1_m[j],
                    "value": loc_jobtypeid1_m[j]
                };
                temparray_jobtype_m.push(loc_jobtypeid1_m[j]);
                temparray_jobtypelabel_m.push(loc_jobtypelabel1_m[j]);
                jobtype_locstore_m.push(temp_object_jobtype_m);
            }
            setoptionSelected(jobtype_locstore_m);
            $('#jobtype_selected_m').val(JSON.stringify(temparray_jobtype_m));
            $('#jobtypeLabel_selected_m').val(JSON.stringify(temparray_jobtypelabel_m));
        }
    }

    return (
        <>
            {/* Removed the 'cd-desktop' class so this unified view displays on all devices */}
            <main className="empr-directory-main">
                <div className="main-bgpatten"></div>
                <section className="headtitle-wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <nav style={{ "--bs-breadcrumb-divider": '>' }} aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item headtitle "><a href="#">Available Jobs</a></li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 ">
                                <div className="white-bg p-5">
                                    <div className="row mb-3">
                                        <div className="col-lg-12 m-auto">
                                            <h1 className="text-center ">
                                                There are   <span className=" red-text">so many opportunities </span>for local careers!
                                            </h1>
                                            <div className="col-12 m-auto">
                                                <hr />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 m-auto text-left">
                                            <p>
                                                To find a great new job with one of the many amazing local employers in your area, simply select your industry, location and experience level below, as well as whether you’d like part-time, full-time, seasonal work or a full time career. Your matches will automatically appear in the box below.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="input-ai-container">
                                            <div className="container mb-4 px-0">
                                                {/* Tabs */}
                                                <div className="align-items-center ai-flex">
                                                    <h4 className="mb-0 mr-2">SEARCH MODE:</h4>
                                                    <ul className="nav nav-tabs" id="jobTabs" role="tablist">
                                                        <li className="nav-item ai-nav">
                                                            <button
                                                                className={`nav-link ${searchMode === "CLASSIC" ? "active" : ""}`}
                                                                id="search-tab"
                                                                data-bs-toggle="tab"
                                                                data-bs-target="#search"
                                                                type="button"
                                                                onClick={() => handleTabChange("CLASSIC")}
                                                            >
                                                                Classic Search
                                                            </button>
                                                        </li>

                                                        <li className="nav-item ai-nav">
                                                            <button
                                                                className={`nav-link ${searchMode === "AI" ? "active" : ""}`}
                                                                id="ai-search-tab"
                                                                data-bs-toggle="tab"
                                                                data-bs-target="#aisearch"
                                                                type="button"
                                                                onClick={() => handleTabChange("AI")}
                                                            >
                                                                AI-Powered Search <label htmlFor="" className="new">New</label>
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>

                                                {/* Tab Content */}
                                                <div className="tab-content p-4">

                                                    {/* AI Job Search */}
                                                    {searchMode === "AI" && (
                                                        <div className="tab-pane fade show active" id="aisearch">
                                                            <div className="position-relaive">
                                                                <textarea
                                                                    className="ai-form-control"
                                                                    placeholder="Describe your ideal job (e.g., Remote senior software engineer role focusing on machine learning)"
                                                                    value={aiQuery}
                                                                    onChange={(e) => setAiQuery(e.target.value)}
                                                                ></textarea>
                                                                <button
                                                                    className="btn btn-primary ai-search-button"
                                                                    onClick={() => runAISearch(1)}
                                                                    disabled={aiLoading}
                                                                >


                                                                    <img src="/images/roboto.png" alt="AI" className="me-2" />
                                                                    {aiLoading ? "Searching…" : "AI Search"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Classic Search */}
                                                    {searchMode === "CLASSIC" && (
                                                        <div className="tab-pane fade show active" id="search" role="tabpanel">
                                                            <div className="filter-wrapper">
                                                                <div className="filter-card">
                                                                    {/* Keywords */}
                                                                    <div className="filter-group full-width">
                                                                        <label className="label">KEYWORDS</label>
                                                                        <input
                                                                            type="text"
                                                                            id="search_text"
                                                                            className="input"
                                                                            placeholder="Search by Company / Job Title / Summary"
                                                                        />
                                                                    </div>

                                                                    {/* Dropdown Row */}
                                                                    <div className="filter-row">
                                                                        {/* Industry */}
                                                                        <div className="filter-group" ref={industryRef}>
                                                                            <label className="label">INDUSTRY</label>
                                                                            <ReactSelect
                                                                                options={mulcategories_d}
                                                                                isMulti
                                                                                closeMenuOnSelect={false}
                                                                                hideSelectedOptions={false}
                                                                                components={{ Option: CustomOption, ValueContainer: CustomValueContainer }}
                                                                                onChange={handleChangeForCate_d}
                                                                                value={optionCatSelected_d}
                                                                                placeholder="Select Industry"

                                                                                menuIsOpen={menus.industry}
                                                                                onMenuOpen={() => setMenus(p => ({ ...p, industry: true }))}
                                                                                onMenuClose={() => setMenus(p => ({ ...p, industry: false }))}
                                                                            />
                                                                        </div>

                                                                        {/* Location */}
                                                                        <div className="filter-group" ref={locationRef}>
                                                                            <label className="label">LOCATION</label>
                                                                            <ReactSelect
                                                                                options={mullocationCounty}
                                                                                isMulti
                                                                                closeMenuOnSelect={false}
                                                                                hideSelectedOptions={false}
                                                                                components={{ Option: CustomOption, ValueContainer: CustomValueContainer }}
                                                                                onChange={handleChangeForLocation_d}
                                                                                value={mullocationCountyselected_d}
                                                                                placeholder="Select Location"

                                                                                menuIsOpen={menus.location}
                                                                                onMenuOpen={() => setMenus(p => ({ ...p, location: true }))}
                                                                                onMenuClose={() => setMenus(p => ({ ...p, location: false }))}
                                                                            />
                                                                        </div>

                                                                        {/* Job Type */}
                                                                        <div className="filter-group" ref={jobTypeRef}>
                                                                            <label className="label">JOB TYPE</label>
                                                                            <ReactSelect
                                                                                options={muljobTypes}
                                                                                isMulti
                                                                                closeMenuOnSelect={false}
                                                                                hideSelectedOptions={false}
                                                                                components={{ Option: CustomOption, ValueContainer: CustomValueContainer }}
                                                                                onChange={handleChange_d}
                                                                                value={optionSelected_d}
                                                                                placeholder="Select Job Type"

                                                                                menuIsOpen={menus.jobType}
                                                                                onMenuOpen={() => setMenus(p => ({ ...p, jobType: true }))}
                                                                                onMenuClose={() => setMenus(p => ({ ...p, jobType: false }))}
                                                                            />
                                                                        </div>

                                                                        {/* Education */}
                                                                        <div className="filter-group" ref={educationRef}>
                                                                            <label className="label">EDUCATION</label>
                                                                            <ReactSelect
                                                                                options={muleducation}
                                                                                isMulti
                                                                                closeMenuOnSelect={false}
                                                                                hideSelectedOptions={false}
                                                                                components={{ Option: CustomOption, ValueContainer: CustomValueContainer }}
                                                                                onChange={handleChangeForEdu_d}
                                                                                value={optionEduSelected_d}
                                                                                placeholder="Select Education"

                                                                                menuIsOpen={menus.education}
                                                                                onMenuOpen={() => setMenus(p => ({ ...p, education: true }))}
                                                                                onMenuClose={() => setMenus(p => ({ ...p, education: false }))}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {/* Buttons */}
                                                                    <div className="button-row">
                                                                        <button
                                                                            type="button"
                                                                            className="reset-btn"
                                                                            onClick={ClearAll}
                                                                        >
                                                                            RESET
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="filter-btn"
                                                                            onClick={() => searchInit(ITEMS_PER_PAGE, '1', '1')}
                                                                        >
                                                                            FILTER
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* REQUIRED hidden inputs (DO NOT REMOVE) */}
                                                            <input type="hidden" id="industry_selected" />
                                                            <input type="hidden" id="industryLabel_selected" />
                                                            <input type="hidden" id="location_selected" />
                                                            <input type="hidden" id="locationLabel_selected" />
                                                            <input type="hidden" id="jobtype_selected" />
                                                            <input type="hidden" id="jobtypeLabel_selected" />
                                                            <input type="hidden" id="education_selected" />
                                                            <input type="hidden" id="educationLabel_selected" />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Results Section */}
                                            {((searchMode === "CLASSIC" && availableJobsList.length > 0) ||
                                                (searchMode === "AI" && aiResults.length > 0)) && (
                                                    <div className="container mb-2 px-0">
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <span className="float-end">
                                                                {searchMode === "CLASSIC"
                                                                    ? `${totalItems} Careers - Page ${currentPage} of ${totalpages || 1}`
                                                                    : `${aiTotalItems} Careers - Page ${aiCurrentPage} of ${Math.ceil(aiTotalItems / ITEMS_PER_PAGE) || 1}`
                                                                }
                                                            </span>
                                                        </div>

                                                        {searchMode === "AI" && aiLoading && (
                                                            <div className="text-center py-4 text-muted">
                                                                Searching jobs using AI…
                                                            </div>
                                                        )}

                                                        {searchMode === "AI" && aiError && (
                                                            <div className="alert alert-warning text-center">
                                                                {aiError}
                                                            </div>
                                                        )}

                                                        {searchMode === "AI" && !aiLoading && aiResults.length === 0 && !aiError && (
                                                            <div className="text-center py-5 text-muted border">
                                                                No AI results found. Try refining your description.
                                                            </div>
                                                        )}





                                                        {/* Job Cards Rendering */}
                                                        {jobCards.map((job) => (
                                                            <div className="job-card mb-2" key={job.id}>
                                                                <div className="avl-logo">
                                                                    <img src={job.logoUrl} alt={job.company} />
                                                                </div>
                                                                <div>
                                                                    <div className="job-header">
                                                                        <div>
                                                                            <h2 className="job-title">
                                                                                <Link to={job.jobUrl} onClick={() => handleJobClick(job.id, job.rawJobData)} >{job.title}</Link>
                                                                            </h2>
                                                                            <p className="job-meta">
                                                                                <span className="company">{job.company}</span> | {job.location}
                                                                                {job.postedDate && (
                                                                                    <span className="posted"> Posted: {job.postedDate}</span>
                                                                                )}
                                                                            </p>
                                                                        </div>

                                                                        <div className="ai-shadow-badge">
                                                                            {job.matchPercent !== null && job.matchPercent !== undefined && (
                                                                            <div className={job.matchPercent >= 60 ? "ai-badge" : "ai-badge-red"}>
                                                                                {job.matchPercent}% Match
                                                                            </div>
                                                                        )}

                                                                        {job.jobShadowConcert === 'Y' && (
                                                                            <a
                                                                                href="#"
                                                                                className="tool"
                                                                                data-bs-toggle="tooltip"
                                                                                data-bs-placement="top"
                                                                                data-tip="This company provides job shadow opportunities"
                                                                            >
                                                                                <div className="jshadow-width">
                                                                                    <img src="images/badge.png" alt="" className="w-100" />
                                                                                </div>
                                                                            </a>
                                                                        )}
                                                                        </div>

                                                                    </div>

                                                                    <p
                                                                        className="job-description"
                                                                        dangerouslySetInnerHTML={{ __html: job.summaryHtml }}
                                                                    />

                                                                    {job.skills && job.skills.length > 0 && (
                                                                        <div className="skills-section">
                                                                            <span className="mr-2">Key Skills:</span>
                                                                            <div className="skills">
                                                                                {job.skills.map((skill) => (
                                                                                    <span className="skill text-capitalize" key={skill}>{skill}</span>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {/* Bottom Row Container (ALWAYS SHOWS) */}
                                                                    <div className="d-flex justify-content-between align-items-center py-4">
                                                                        {/* Left Side: Perks */}
                                                                        <div>
                                                                            {job.showPerks && (
                                                                                <div className="perks-avl d-flex align-items-center">
                                                                                    <span className="mr-2">Perks:</span>
                                                                                    <div className="perks-avl-icon">
                                                                                        {job.perks.map((perk) => (
                                                                                            <div key={perk.id}>
                                                                                                <img src={perk.icon} alt={perk.title} title={perk.title} />
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        {/* Right Side: View Job Button */}
                                                                        <Link
                                                                            onClick={() => handleJobClick(job.id, job.rawJobData)}
                                                                            to={job.jobUrl}
                                                                            className="reg-button d-block"
                                                                        >
                                                                            VIEW JOB
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}






                                                        <nav aria-label="..." className="m-auto text-center">
                                                            <ul className="pagination  d-inline-flex">
                                                                {searchMode === "CLASSIC" && availableJobsList.length > 0 && (
                                                                    <Pagination
                                                                        total={totalItems}
                                                                        itemsPerPage={ITEMS_PER_PAGE}
                                                                        currentPage={currentPage}
                                                                        onPageChange={handlePageChange2}
                                                                    />
                                                                )}

                                                                {searchMode === "AI" && aiResults.length > 0 && (
                                                                    <Pagination
                                                                        total={aiTotalItems}
                                                                        itemsPerPage={ITEMS_PER_PAGE}
                                                                        currentPage={aiCurrentPage}
                                                                        onPageChange={handleAiPageChange}
                                                                    />
                                                                )}
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                )}



                                                 {/* STANDALONE EMPTY MESSAGE - Works for both AI and Classic */}
                                                    {/* {jobCards.length === 0 && !aiLoading && (
                                                        <div className="container mb-4 px-0">
                                                            <div className="no-jobs-container text-center py-5 border rounded bg-light">
                                                                <div className="no-jobs-icon mb-3">
                                                                    <i className="fa fa-briefcase fa-3x text-muted" style={{ opacity: 0.5 }}></i>
                                                                </div>

                                                                <p className="text-secondary mx-auto" style={{ maxWidth: "750px" }}>
                                                                    We couldn't find any jobs matching your criteria at the moment.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )} */}



                                            {/* STANDALONE EMPTY MESSAGE - Works for both AI and Classic */}
                                            {jobCards.length === 0 && (
                                                (searchMode === "CLASSIC" && !isClassicLoading) ||
                                                (searchMode === "AI" && !aiLoading && hasSearchedAI)
                                            ) && (
                                                    <div className="container mb-4 px-0">
                                                        <div className="no-jobs-container text-center py-5 border rounded bg-light">
                                                            <div className="no-jobs-icon mb-3">
                                                                <i className="fa fa-briefcase fa-3x text-muted" style={{ opacity: 0.5 }}></i>
                                                            </div>
                                                            <p className="text-secondary mx-auto" style={{ maxWidth: "750px" }}>
                                                                We couldn't find any jobs matching your criteria at the moment.
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>

                                    {/* HIDDEN LEGACY BLOCK - KEPT TO PREVENT BREAKING jQUERY */}
                                    <div className="row" style={{ display: "none" }}>
                                        <div className="col-lg-4 mb-4">
                                            <div className="card p-3 mb-3 ">
                                                <div className="bg-heading"><h3 className="mb-0">Filter Jobs</h3></div>
                                                <div className="py-3 text-start">
                                                    <b className="text-uppercase">Keywords</b>
                                                    <form onSubmit={handleSubmit(submitValue)} className=" search-bar my-2 w-100">
                                                        <input className="form-control me-2" type="search" aria-label="Search" id="search_text" name="search_text" placeholder="Search by Company / Job Title / Summary" />
                                                        <button className="border-0 p-0 dir-search" type="submit" onClick={() => { searchInit(ITEMS_PER_PAGE, "1", "1") }}><img src="images/search-icon.JPG" alt="" /></button>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* END HIDDEN LEGACY BLOCK */}

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
};

AvailableJobsHTOAI.propTypes = {};

AvailableJobsHTOAI.defaultProps = {};

export default AvailableJobsHTOAI;